import Menu from "../components/subsidiary/Menu/Menu"
import {createBrowserHistory} from "history"
import {Route, Routes, useLocation} from 'react-router-dom'
import Loader from "../components/subsidiary/Loader/Loader"
import Home from "../components/Home/Home"
import News from "../components/News/News"
import CurrentNews from "../components/CurrentNews/CurrentNews"
import Tickets from "../components/Tickets/Tickets"
import Documents from "../components/Documents/Documents"
import Calendar from "../components/Calendar/Calendar"
import NewTicket from "../components/NewTicket/NewTicket"
import Proposal from "../components/Proposal/Proposal"
import Profile from "../components/Profile/Profile"
import Settings from "../components/Settings/Settings"
import Login from "../components/Login/Login"
import SMS from "../components/SMS/SMS"
import React, {useEffect, useState} from 'react'
import Alerts from "../components/subsidiary/Alert/Alert"
import {useDispatch, useSelector} from 'react-redux'
import Header from '../components/subsidiary/Header/Header'
import {checkUser} from '../components/Login/loginSlice'
import CurrentTicket from '../components/CurrentTicket/CurrentTicket'
import Navigation from "../components/Navigation/Navigation"
import Sms from "../components/Settings/components/Sms/Sms"
import Event from "../components/Event/Event"
import CurrentProposal from "../components/CurrentProposal/CurrentProposal";
import Payments from "../components/Payments/Payments";
import ExchangeRates from "../components/ExchangeRates/ExchangeRates";
import WorkCalendar from "../components/WorkCalendar/WorkCalendar";
import Pause from "../components/Pause/Pause";
import PauseExercise from "../components/Pause/PauseExercise";
import CurrentPayment from "../components/CurrentPayment/CurrentPayment";
import Notification from "../components/Settings/Notification";
import NotificationsPage from "../components/Notifications/NotificationsPage";
import NewYearEventPage from "../components/Event/NewYearEvent/NewYearEventPage";
import EventApply from "../components/Event/NewYearEvent/EventApply";
import SuccessPage from "../components/Event/NewYearEvent/SuccessPage";
import LoginChoosePage from "../components/Login/LoginChoosePage";
import OutgoingCall from "../components/Login/OutgoingCall";
import {ContestPage} from "../components/Event/Contest/ContestPage/ContestPage";
import {MyTeamPage} from "../components/Event/Contest/MyTeam/MyTeamPage";
import {DownloadVideo} from "../components/Event/Contest/DownloadVideo/DownloadVideo";
import {Success} from "../components/Event/Contest/Success/Success";
import {Winners} from "../components/Event/Contest/Winners/Winners";
import {City} from "../components/Event/Contest/City/City";
import AllVideos from "../components/Event/AllVideos/AllVideos";
import TicketPage from "../components/Tickets/TicketsPage/TicketPage";
import Story from "../components/Stories/Story";
import DeclarationFp from "../components/Declaration/DeclarationFp";
import DeclarationSuccess from "../components/Declaration/DeclarationSuccess";
import Declaration from "../components/Declaration/declaration";
import DeclarationTypeSelection from "../components/Declaration/DeclarationTypeSelection";
import ChooseTopic from "../components/Event/Contest/ChooseThema/ChooseTopic";
import PrivacyPolicy from "../components/PrivacyPolicy/PrivacyPolicy"
import WidgetController from "../components/WidgetController/WidgetController"

export const history = createBrowserHistory()

const METRIKA_ID = 108236380

function MetrikaRouteTracker() {
    const location = useLocation()
    const initialPageRef = React.useRef(location.pathname + location.search)

    useEffect(() => {
        const page = location.pathname + location.search
        if (page === initialPageRef.current) return

        if (typeof window !== 'undefined' && typeof window.ym === 'function') {
            window.ym(METRIKA_ID, 'hit', {
                page,
                url: window.location.href,
                title: document.title,
            })
        }

        initialPageRef.current = page
    }, [location.pathname, location.search])

    return null
}

function App() {
    const dispatch = useDispatch()
    const token = useSelector(state => state.loginSlice.token)
    const isLoaded = useSelector(state => state.loginSlice.isLoaded)
    const [autologinning, setAutologinning] = useState(true);
    const loggedIn = useSelector(state => state.loginSlice.loggedIn)

    useEffect(() => {
        if (autologinning) {
            dispatch(checkUser({token})).then((params) => {
                if (!params.error) {
                    setAutologinning(false)
                }
            })
        }
    }, [dispatch, autologinning, token])

    return (
        <div className="App">
            <Alerts/>
            <MetrikaRouteTracker/>
            <Header/>
            {isLoaded ? <>
                <Routes>
                    <Route path="/" element={!loggedIn ? <Home/> : <Navigation/>}/>
                    {loggedIn ?
                        <>
                            <Route path="/news" element={<News/>}/>
                            <Route path="/news/:id" element={<CurrentNews/>}/>
                            {/*<Route path="/documents" element={<Documents/>}/>*/}
                            <Route path="/calendar" element={<Calendar/>}/>
                            <Route path="/calendar/:id" element={<Event/>}/>
                            <Route path="/tickets" element={<Tickets/>}/>
                            <Route path="/ticketsAbout" element={<TicketPage/>}/>
                            <Route path="/tickets/newticket" element={<NewTicket/>}/>
                            <Route path="/tickets/:id" element={<CurrentTicket/>}/>
                            <Route path="/proposal" element={<Proposal/>}/>
                            <Route path="/proposal/:id" element={<CurrentProposal/>}/>
                            <Route path="/payments" element={<Payments/>}/>
                            <Route path="/payments/:id" element={<CurrentPayment/>}/>
                            <Route path="/profile" element={<Profile/>}/>
                            <Route path="/settings/:type" element={<Settings/>}/>
                            <Route path="/settings/notification" element={<Notification/>}/>
                            <Route path="/notifications" element={<NotificationsPage/>}/>
                            <Route path="/settings/:type/sms" element={<Sms/>}/>
                            <Route path="/event" element={<NewYearEventPage/>}/>
                            <Route path="/event/about" element={<NewYearEventPage/>}/>
                            <Route path="/event/apply" element={<EventApply/>}/>
                            <Route path="/event/success" element={<SuccessPage/>}/>
                            <Route path="/contest/:contest" element={<ContestPage/>}/>
                            <Route path={"/my-team"} element={<MyTeamPage/>}/>
                            <Route path={"/city"} element={<City/>}/>
                            <Route path={"/chooseTopic"} element={<ChooseTopic/>}/>
                            <Route path={"/video"} element={<DownloadVideo/>}/>
                            <Route path={"/success"} element={<Success/>}/>
                            <Route path={"/winners"} element={<Winners/>}/>
                            <Route path={"/voteList"} element={<AllVideos/>}/>
                            <Route path={"/story"} element={<Story/>}/>
                            <Route path="/declaration" element={<DeclarationFp/>}/>
                            <Route path="/declaration/select-type" element={<DeclarationTypeSelection/>}/>
                            <Route path="/declaration/success" element={<DeclarationSuccess/>}/>
                            <Route path="/declarations/:id" element={<Declaration/>}/>
                            <Route path="/declarations/:id/review" element={<Declaration/>}/>
                        </> : <>
                            <Route
                                path="*"
                                element={<LoginChoosePage to="/"/>}
                            />
                            <Route path='/login/incomingCall' element={<Login/>}/>
                            <Route path='/login/sms' element={<SMS/>}/>
                            <Route path='/login/outGoingCall' element={<Login/>}/>
                            <Route path='/outgoingCall' element={<OutgoingCall/>}/>
                        </>
                    }
                    <Route path="/documents" element={<Documents loggedIn={loggedIn} />} />
                    <Route path="/exchange-rates" element={<ExchangeRates/>} />
                    <Route path="/work-calendar" element={<WorkCalendar/>} />
                    <Route path="/pause" element={<Pause/>} />
                    <Route path="/pause/:id" element={<PauseExercise/>} />
                    <Route path="/privacypolicy" element={<PrivacyPolicy/>} />
                </Routes>
            </> : <Loader/>}
            <Menu/>
            <WidgetController/>
        </div>
    )
}

export default App;

